export const isPhoneNumber = (phone: string) => {
  const normalized = phone.replace(/[\s\-()]/g, '');
  const regex = /^(\+?\d{1,3})?\d{10}$/;

  return regex.test(normalized);
};
